import { ObservableQuery } from '@apollo/client';
import { User } from '@ih/app/shared/apis/interfaces';

export class GetUserSuccessAction {
  public static readonly type = '[User] GetUserSuccessAction';
  constructor(
    public readonly result: ObservableQuery.Result<{ findUniqueUser: User }>,
  ) {}
}
